function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17 0a17 17 0 0 0-6.2 32.84c-.14-1.35-.28-3.41.07-4.88.3-1.33 2-8.45 2-8.45s-.52-1.02-.52-2.53c0-2.36 1.37-4.12 3.08-4.12 1.45 0 2.15 1.08 2.15 2.39 0 1.46-.93 3.64-1.4 5.66-.41 1.7.84 3.07 2.5 3.07 3.03 0 5.35-3.18 5.35-7.78 0-4.07-2.92-6.92-7.1-6.92a7.36 7.36 0 0 0-7.68 7.38 6.6 6.6 0 0 0 1.27 3.88c.14.17.16.32.12.49l-.47 1.92c-.08.32-.25.38-.57.23-2.13-.99-3.46-4.1-3.46-6.59 0-5.36 3.9-10.29 11.24-10.29 5.9 0 10.48 4.2 10.48 9.83 0 5.86-3.7 10.57-8.82 10.57-1.72 0-3.34-.9-3.9-1.95l-1.06 4.04a18.92 18.92 0 0 1-2.11 4.46A17 17 0 1 0 17 0z"
});

var SvgPinterest = function SvgPinterest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinterest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinterest.a25955a8.svg";
export { ForwardRef as ReactComponent };